<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Finalizar Atendimento"
    >
        <Form
            :plantao-id="plantaoId"
            :data="data"
            ref="Form"
            @save="$emit('save')"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                v-if="showFinalizarAtendimento()"
                @click="$refs.Form.save()"
                color="outline-success"
            >
                Finalizar atendimento
            </rkm-button>

            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                v-if="data.additionals.fromObservacao"
                @click="save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        save() {

            this.$refs.Form.validate().then(valid => valid && this.$emit('click-to-save'))
        },
        showFinalizarAtendimento() {

            return this.data.model.centroCustoIdPara === null
                && (this.data.model.solicitouReavaliacao === null
                    || this.data.model.solicitouReavaliacao === false)
                && !this.data.additionals.fromObservacao
        }
    },
    props: {
        data: { type: Object, required: true },
        plantaoId: { type: [String, Number], required: true },
    },
}
</script>